import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useSelector } from 'react-redux';

import { LayoutBlock } from '../../components/LayoutBlock';
import { TransportAccessibilityRate } from '../../components/TransportAccessibilityRate';
import {
  getInfrastructureFromBuilder,
  getTransportAccessibility,
  getTransportAccessibilitySource,
} from '../../selectors/newbuilding';
import { InfrastructureFromBuilderContainer } from './parts/InfrastructureFromBuilderContainer';
import { TransportAccessibilityContainer } from './parts/TransportAccessibilityContainer';
import { trackIndexTransportMoreClick, trackIndexTransportShow } from './tracking';
import { getIsMapServicesVisible } from '../../selectors/mapServices';

export const TransportAccessibilityRateContainer: React.FC = () => {
  const departmentLink = useSelector(getTransportAccessibilitySource);
  const isMapServicesVisible = useSelector(getIsMapServicesVisible);
  const transportAccessibility = useSelector(getTransportAccessibility);
  const infrastructure = useSelector(getInfrastructureFromBuilder);
  const isAvailable = Boolean(transportAccessibility || infrastructure);

  // TODO: Проверка на isMapServicesVisible будет удалена при выпиле фича-флага в NB-1153.
  if (!isAvailable || isMapServicesVisible) {
    return null;
  }

  return (
    <LayoutBlock>
      <ActionAfterViewObserver callback={trackIndexTransportShow} triggerOnce>
        <TransportAccessibilityRate
          departmentLink={departmentLink}
          onDepartmentLinkClick={trackIndexTransportMoreClick}
          transportAccessibility={
            transportAccessibility && <TransportAccessibilityContainer accessibility={transportAccessibility} />
          }
          infrastructureFromBuilder={
            infrastructure && <InfrastructureFromBuilderContainer infrastructure={infrastructure} />
          }
        />
      </ActionAfterViewObserver>
    </LayoutBlock>
  );
};
